module.exports = __webpack_public_path__ + "static/media/icon-wms.82b3e7e6.png";